import React, { useState, useEffect } from "react";
import { Box, TextField, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { useUser } from "../../../../../context/AuthContext";

function ViewLogisticsVendorMaster(props) {
  const { user } = useUser();

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "26.5rem",
        // maxWidth:"100%",
        height: "100vh",
        display: "flex",
        justifyContent: "space-btween",
        backgroundColor: "transparent",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton
          onClick={() => props.setViewVendor(false)}
          sx={{ color: "black" }}
        >
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          padding: "24px",
          backgroundColor: "#fff",
          height: "100%",
          width: "100%",
          overflowY: "scroll",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            textDecoration: "underline",
            fontWeight: "bold",

            mb: 2,
          }}
        >
          Logistics Vendor Details
        </Typography>
        <Box>
          <Box display="flex" gap={10}>
            <Box>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "bold", mb: 1 }}
              >
                Date
              </Typography>

              <p>
                {new Date(props.selectedLogestic?.createdAt).toLocaleDateString(
                  "en-GB",
                  { day: "2-digit", month: "2-digit", year: "numeric" }
                ) ?? ""}
                {/* {new Date(props.selectedLogestic?.createdAt).toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' }) ?? ""} */}
              </p>
            </Box>
            <Box>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "bold", mb: 1 }}
              >
                Logistics Vendor
              </Typography>
              <p> {props.selectedLogestic?.logisticVendorLegalName ?? ""}</p>
            </Box>
          </Box>
        </Box>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
          Address
        </Typography>
        <Box display="flex" gap={1} sx={{ width: "100%" }}>
          <Box style={{ width: "50%" }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
              AddressLine1
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {/* {props.index?.role?.map((item) => item.name).join(', ') ?? ""} */}
              {props.selectedLogestic?.addressLine1 ?? ""}
            </p>
          </Box>
          <Box style={{ width: "50%" }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
              AddressLine2
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {props.selectedLogestic?.addressLine2 === ""
                ? "-"
                : props.selectedLogestic?.addressLine2}
            </p>
          </Box>
        </Box>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
          Country
        </Typography>
        <p>{props.selectedLogestic?.country ?? ""}</p>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
          State
        </Typography>
        <p>{props.selectedLogestic?.state ?? ""}</p>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
          Pin Code
        </Typography>
        <p>{props.selectedLogestic?.pinCode ?? ""}</p>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
          Contact Person Name
        </Typography>
        <p>{props.selectedLogestic?.contactPersonName ?? ""}</p>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
          Contact Person Mobile
        </Typography>
        <p>
          {props.selectedLogestic?.countryCode + " " ?? ""}
          {props.selectedLogestic?.contactPersonMobile ?? ""}
        </p>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
          Contact Person Email
        </Typography>
        <p>{props.selectedLogestic?.contactPersonEmail ?? ""}</p>

        {!user?.companyAdmin && (
          <Box>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#0a3f73",
                textTransform: "none",
                marginTop: "10%",
              }}
              onClick={props.handleEdit}
            >
              Edit
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );

  return (
    <div>
      <Drawer
        sx={{
          backgroundColor: "transparent",
          "& .MuiDrawer-paper": {
            // This targets the paper component within the Drawer
            backgroundColor: "transparent", // Make paper transparent
            boxShadow: "none", // Optional: Remove any shadow
          },
        }}
        anchor="right"
        open={props.viewVendor}
        onClose={() => props.setViewVendor(false)}
      >
        {list()}
      </Drawer>
    </div>
  );
}

export default ViewLogisticsVendorMaster;

//// custom textfield

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    height: "40px", // Adjust height as needed
  },
  "& .MuiSelect-select": {
    height: "56px", // Adjust height as needed
    display: "flex",
    alignItems: "center",
  },
}));
